import { createContext } from 'react';
import Config from './configStore';
import Common from './commonStore';
import Project from './projectStore';
import Diff from './diffStore';
import Team from './teamStore';
import EnumStore from './enumStore';

// 构建store集合
/**
 * Common 是顶层SPA的Store
 * Config 是api配置页面的Store
 * ...其他独立store需要单独添加 类似 namespace
 */
function createStores() {
  return {
    commonStore: new Common.Store(),
    configStore: new Config.Store(),
    projectStore: new Project.Store(),
    diffStore: new Diff.Store(),
    teamStore: new Team.Store(),
    enumStore: new EnumStore.Store(),
  };
}
const Store = createStores();

export const homeStore = Store;
export const storeContext = createContext(Store);
